import { jsx as _jsx } from "react/jsx-runtime";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
export const toaster = (type, messages) => {
    const sAlert = withReactContent(Swal);
    // Render messages for sweet alert
    const renderError = () => {
        const element = document.createElement("div");
        messages.forEach((message) => {
            element.innerHTML += `
        <span>${message}</span>
      `;
        });
        return element;
    };
    if (type === "success") {
        toast.success(() => messages.map((message, index) => (_jsx("span", { children: message }, index))));
    }
    else if (type === "errors") {
        toast.error(() => messages.map((message, index) => (_jsx("span", { children: message }, index))));
    }
    else {
        sAlert.fire({
            title: renderError(),
            confirmButtonText: "تایید",
        });
    }
};
